// Countries
export default [
  { label: 'common.countries.optionAfghanistan', value: 'AF' },
  { label: 'common.countries.optionAlandIslands', value: 'AX' },
  { label: 'common.countries.optionAlbania', value: 'AL' },
  { label: 'common.countries.optionAlgeria', value: 'DZ' },
  { label: 'common.countries.optionAmericanSamoa', value: 'AS' },
  { label: 'common.countries.optionAndorrA', value: 'AD' },
  { label: 'common.countries.optionAngola', value: 'AO' },
  { label: 'common.countries.optionAnguilla', value: 'AI' },
  { label: 'common.countries.optionAntarctica', value: 'AQ' },
  { label: 'common.countries.optionAntiguaAndBarbuda', value: 'AG' },
  { label: 'common.countries.optionArgentina', value: 'AR' },
  { label: 'common.countries.optionArmenia', value: 'AM' },
  { label: 'common.countries.optionAruba', value: 'AW' },
  { label: 'common.countries.optionAustralia', value: 'AU' },
  { label: 'common.countries.optionAustria', value: 'AT' },
  { label: 'common.countries.optionAzerbaijan', value: 'AZ' },
  { label: 'common.countries.optionBahamas', value: 'BS' },
  { label: 'common.countries.optionBahrain', value: 'BH' },
  { label: 'common.countries.optionBangladesh', value: 'BD' },
  { label: 'common.countries.optionBarbados', value: 'BB' },
  { label: 'common.countries.optionBelarus', value: 'BY' },
  { label: 'common.countries.optionBelgium', value: 'BE' },
  { label: 'common.countries.optionBelize', value: 'BZ' },
  { label: 'common.countries.optionBenin', value: 'BJ' },
  { label: 'common.countries.optionBermuda', value: 'BM' },
  { label: 'common.countries.optionBhutan', value: 'BT' },
  { label: 'common.countries.optionBolivia', value: 'BO' },
  { label: 'common.countries.optionBosniaAndHerzegovina', value: 'BA' },
  { label: 'common.countries.optionBotswana', value: 'BW' },
  { label: 'common.countries.optionBouvetIsland', value: 'BV' },
  { label: 'common.countries.optionBrazil', value: 'BR' },
  { label: 'common.countries.optionBritishIndianOceanTerritory', value: 'IO' },
  { label: 'common.countries.optionBruneiDarussalam', value: 'BN' },
  { label: 'common.countries.optionBulgaria', value: 'BG' },
  { label: 'common.countries.optionBurkinaFaso', value: 'BF' },
  { label: 'common.countries.optionBurundi', value: 'BI' },
  { label: 'common.countries.optionCambodia', value: 'KH' },
  { label: 'common.countries.optionCameroon', value: 'CM' },
  { label: 'common.countries.optionCanada', value: 'CA' },
  { label: 'common.countries.optionCapeVerde', value: 'CV' },
  { label: 'common.countries.optionCaymanIsland', value: 'KY' },
  { label: 'common.countries.optionCentralAfricanRepublic', value: 'CF' },
  { label: 'common.countries.optionChad', value: 'TD' },
  { label: 'common.countries.optionChile', value: 'CL' },
  { label: 'common.countries.optionChina', value: 'CN' },
  { label: 'common.countries.optionChristmasIsland', value: 'CX' },
  { label: 'common.countries.optionCocosIslands', value: 'CC' },
  { label: 'common.countries.optionColombia', value: 'CO' },
  { label: 'common.countries.optionComoros', value: 'KM' },
  { label: 'common.countries.optionCongo', value: 'CG' },
  {
    label: 'common.countries.optionCongoTheDemocraticRepublicOfThe',
    value: 'CD'
  },
  { label: 'common.countries.optionCookIslands', value: 'CK' },
  { label: 'common.countries.optionCostaRica', value: 'CR' },
  { label: 'common.countries.optionCoteIvoire', value: 'CI' },
  { label: 'common.countries.optionCroatia', value: 'HR' },
  { label: 'common.countries.optionCuba', value: 'CU' },
  { label: 'common.countries.optionCyprus', value: 'CY' },
  { label: 'common.countries.optionCzechRepublic', value: 'CZ' },
  { label: 'common.countries.optionDenmark', value: 'DK' },
  { label: 'common.countries.optionDjibouti', value: 'DJ' },
  { label: 'common.countries.optionDominica', value: 'DM' },
  { label: 'common.countries.optionDominicanRepublic', value: 'DO' },
  { label: 'common.countries.optionEcuador', value: 'EC' },
  { label: 'common.countries.optionEgypt', value: 'EG' },
  { label: 'common.countries.optionElSalvador', value: 'SV' },
  { label: 'common.countries.optionEquatorialGuinea', value: 'GQ' },
  { label: 'common.countries.optionEritrea', value: 'ER' },
  { label: 'common.countries.optionEstonia', value: 'EE' },
  { label: 'common.countries.optionEthiopia', value: 'ET' },
  { label: 'common.countries.optionFalklandIslands', value: 'FK' },
  { label: 'common.countries.optionFaroeIslands', value: 'FO' },
  { label: 'common.countries.optionFiji', value: 'FJ' },
  { label: 'common.countries.optionFinland', value: 'FI' },
  { label: 'common.countries.optionFrance', value: 'FR' },
  { label: 'common.countries.optionFrenchGuiana', value: 'GF' },
  { label: 'common.countries.optionFrenchPolynesia', value: 'PF' },
  { label: 'common.countries.optionFrenchSouthernTerritories', value: 'TF' },
  { label: 'common.countries.optionGabon', value: 'GA' },
  { label: 'common.countries.optionGambia', value: 'GM' },
  { label: 'common.countries.optionGeorgia', value: 'GE' },
  { label: 'common.countries.optionGermany', value: 'DE' },
  { label: 'common.countries.optionGhana', value: 'GH' },
  { label: 'common.countries.optionGibraltar', value: 'GI' },
  { label: 'common.countries.optionGreece', value: 'GR' },
  { label: 'common.countries.optionGreenland', value: 'GL' },
  { label: 'common.countries.optionGrenada', value: 'GD' },
  { label: 'common.countries.optionGuadeloupe', value: 'GP' },
  { label: 'common.countries.optionGuam', value: 'GU' },
  { label: 'common.countries.optionGuatemala', value: 'GT' },
  { label: 'common.countries.optionGuernsey', value: 'GG' },
  { label: 'common.countries.optionGuinea', value: 'GN' },
  { label: 'common.countries.optionGuineaBissau', value: 'GW' },
  { label: 'common.countries.optionGuyana', value: 'GY' },
  { label: 'common.countries.optionHaiti', value: 'HT' },
  {
    label: 'common.countries.optionHeardIslandAndMcdonaldIslands',
    value: 'HM'
  },
  { label: 'common.countries.optionHolySee', value: 'VA' },
  { label: 'common.countries.optionHonduras', value: 'HN' },
  { label: 'common.countries.optionHongKong', value: 'HK' },
  { label: 'common.countries.optionHungary', value: 'HU' },
  { label: 'common.countries.optionIceland', value: 'IS' },
  { label: 'common.countries.optionIndia', value: 'IN' },
  { label: 'common.countries.optionIndonesia', value: 'ID' },
  { label: 'common.countries.optionIranIslamicRepublicOf', value: 'IR' },
  { label: 'common.countries.optionIraq', value: 'IQ' },
  { label: 'common.countries.optionIreland', value: 'IE' },
  { label: 'common.countries.optionIsleofMan', value: 'IM' },
  { label: 'common.countries.optionIsrael', value: 'IL' },
  { label: 'common.countries.optionItaly', value: 'IT' },
  { label: 'common.countries.optionJamaica', value: 'JM' },
  { label: 'common.countries.optionJapan', value: 'JP' },
  { label: 'common.countries.optionJersey', value: 'JE' },
  { label: 'common.countries.optionJordan', value: 'JO' },
  { label: 'common.countries.optionKazakhstan', value: 'KZ' },
  { label: 'common.countries.optionKenya', value: 'KE' },
  { label: 'common.countries.optionKiribati', value: 'KI' },
  {
    label: 'common.countries.optionKoreaDemocraticPeopleRepublicOf',
    value: 'KP'
  },
  { label: 'common.countries.optionKoreaRepublicOf', value: 'KR' },
  { label: 'common.countries.optionKuwait', value: 'KW' },
  { label: 'common.countries.optionKyrgyzstan', value: 'KG' },
  { label: 'common.countries.optionLaoPeopleDemocraticRepublic', value: 'LA' },
  { label: 'common.countries.optionLatvia', value: 'LV' },
  { label: 'common.countries.optionLebanon', value: 'LB' },
  { label: 'common.countries.optionLesotho', value: 'LS' },
  { label: 'common.countries.optionLiberia', value: 'LR' },
  { label: 'common.countries.optionLibyanArabJamahiriya', value: 'LY' },
  { label: 'common.countries.optionLiechtenstein', value: 'LI' },
  { label: 'common.countries.optionLithuania', value: 'LT' },
  { label: 'common.countries.optionLuxembourg', value: 'LU' },
  { label: 'common.countries.optionMacao', value: 'MO' },
  {
    label: 'common.countries.optionMacedoniaTheFormerYugoslavRepublicof',
    value: 'MK'
  },
  { label: 'common.countries.optionMadagascar', value: 'MG' },
  { label: 'common.countries.optionMalawi', value: 'MW' },
  { label: 'common.countries.optionMalaysia', value: 'MY' },
  { label: 'common.countries.optionMaldives', value: 'MV' },
  { label: 'common.countries.optionMali', value: 'ML' },
  { label: 'common.countries.optionMalta', value: 'MT' },
  { label: 'common.countries.optionMarshallIslands', value: 'MH' },
  { label: 'common.countries.optionMartinique', value: 'MQ' },
  { label: 'common.countries.optionMauritania', value: 'MR' },
  { label: 'common.countries.optionMauritius', value: 'MU' },
  { label: 'common.countries.optionMayotte', value: 'YT' },
  { label: 'common.countries.optionMexico', value: 'MX' },
  { label: 'common.countries.optionMicronesiaFederatedStatesof', value: 'FM' },
  { label: 'common.countries.optionMoldovaRepublicOf', value: 'MD' },
  { label: 'common.countries.optionMonaco', value: 'MC' },
  { label: 'common.countries.optionMongolia', value: 'MN' },
  { label: 'common.countries.optionMontserrat', value: 'MS' },
  { label: 'common.countries.optionMorocco', value: 'MA' },
  { label: 'common.countries.optionMozambique', value: 'MZ' },
  { label: 'common.countries.optionMyanmar', value: 'MM' },
  { label: 'common.countries.optionNamibia', value: 'NA' },
  { label: 'common.countries.optionNauru', value: 'NR' },
  { label: 'common.countries.optionNepal', value: 'NP' },
  { label: 'common.countries.optionNetherlands', value: 'NL' },
  { label: 'common.countries.optionNetherlandsAntilles', value: 'AN' },
  { label: 'common.countries.optionNewCaledonia', value: 'NC' },
  { label: 'common.countries.optionNewZealand', value: 'NZ' },
  { label: 'common.countries.optionNicaragua', value: 'NI' },
  { label: 'common.countries.optionNiger', value: 'NE' },
  { label: 'common.countries.optionNigeria', value: 'NG' },
  { label: 'common.countries.optionNiue', value: 'NU' },
  { label: 'common.countries.optionNorfolkIsland', value: 'NF' },
  { label: 'common.countries.optionNorthernMarianaIslands', value: 'MP' },
  { label: 'common.countries.optionNorway', value: 'NO' },
  { label: 'common.countries.optionOman', value: 'OM' },
  { label: 'common.countries.optionPakistan', value: 'PK' },
  { label: 'common.countries.optionPalau', value: 'PW' },
  { label: 'common.countries.optionPalestinianTerritory', value: 'PS' },
  { label: 'common.countries.optionPanama', value: 'PA' },
  { label: 'common.countries.optionPapuaNewGuinea', value: 'PG' },
  { label: 'common.countries.optionParaguay', value: 'PY' },
  { label: 'common.countries.optionPeru', value: 'PE' },
  { label: 'common.countries.optionPhilippines', value: 'PH' },
  { label: 'common.countries.optionPitcairn', value: 'PN' },
  { label: 'common.countries.optionPoland', value: 'PL' },
  { label: 'common.countries.optionPortugal', value: 'PT' },
  { label: 'common.countries.optionPuertoRico', value: 'PR' },
  { label: 'common.countries.optionQatar', value: 'QA' },
  { label: 'common.countries.optionReunion', value: 'RE' },
  { label: 'common.countries.optionRomania', value: 'RO' },
  { label: 'common.countries.optionRussianFederation', value: 'RU' },
  { label: 'common.countries.optionRWANDA', value: 'RW' },
  { label: 'common.countries.optionSaintHelena', value: 'SH' },
  { label: 'common.countries.optionSaintKittsAndNevis', value: 'KN' },
  { label: 'common.countries.optionSaintLucia', value: 'LC' },
  { label: 'common.countries.optionSaintPierreAndMiquelon', value: 'PM' },
  { label: 'common.countries.optionSaintVincentAndTheGrenadines', value: 'VC' },
  { label: 'common.countries.optionSamoa', value: 'WS' },
  { label: 'common.countries.optionSanMarino', value: 'SM' },
  { label: 'common.countries.optionSaoTomeAndPrincipe', value: 'ST' },
  { label: 'common.countries.optionSaudiArabia', value: 'SA' },
  { label: 'common.countries.optionSenegal', value: 'SN' },
  { label: 'common.countries.optionSerbiaAndMontenegro', value: 'CS' },
  { label: 'common.countries.optionSeychelles', value: 'SC' },
  { label: 'common.countries.optionSierraLeone', value: 'SL' },
  { label: 'common.countries.optionSingapore', value: 'SG' },
  { label: 'common.countries.optionSlovakia', value: 'SK' },
  { label: 'common.countries.optionSlovenia', value: 'SI' },
  { label: 'common.countries.optionSolomonIslands', value: 'SB' },
  { label: 'common.countries.optionSomalia', value: 'SO' },
  { label: 'common.countries.optionSouthAfrica', value: 'ZA' },
  {
    label: 'common.countries.optionSouthGeorgiaSouthSandwichIslands',
    value: 'GS'
  },
  { label: 'common.countries.optionSpain', value: 'ES' },
  { label: 'common.countries.optionSriLanka', value: 'LK' },
  { label: 'common.countries.optionSudan', value: 'SD' },
  { label: 'common.countries.optionSurilabel', value: 'SR' },
  { label: 'common.countries.optionSvalbardAndJanMayen', value: 'SJ' },
  { label: 'common.countries.optionSwaziland', value: 'SZ' },
  { label: 'common.countries.optionSweden', value: 'SE' },
  { label: 'common.countries.optionSwitzerland', value: 'CH' },
  { label: 'common.countries.optionSyrianArabRepublic', value: 'SY' },
  { label: 'common.countries.optionTaiwanProvinceOfChina', value: 'TW' },
  { label: 'common.countries.optionTajikistan', value: 'TJ' },
  { label: 'common.countries.optionTanzaniaUnitedRepublicOf', value: 'TZ' },
  { label: 'common.countries.optionThailand', value: 'TH' },
  { label: 'common.countries.optionTimorLeste', value: 'TL' },
  { label: 'common.countries.optionTogo', value: 'TG' },
  { label: 'common.countries.optionTokelau', value: 'TK' },
  { label: 'common.countries.optionTonga', value: 'TO' },
  { label: 'common.countries.optionTrinidadAndTobago', value: 'TT' },
  { label: 'common.countries.optionTunisia', value: 'TN' },
  { label: 'common.countries.optionTurkey', value: 'TR' },
  { label: 'common.countries.optionTurkmenistan', value: 'TM' },
  { label: 'common.countries.optionTurksAndCaicosIslands', value: 'TC' },
  { label: 'common.countries.optionTuvalu', value: 'TV' },
  { label: 'common.countries.optionUganda', value: 'UG' },
  { label: 'common.countries.optionUkraine', value: 'UA' },
  { label: 'common.countries.optionUnitedArabEmirates', value: 'AE' },
  { label: 'common.countries.optionUnitedKingdom', value: 'UK' },
  { label: 'common.countries.optionUnitedStates', value: 'US' },
  {
    label: 'common.countries.optionUnitedStatesMinorOutlyingIslands',
    value: 'UM'
  },
  { label: 'common.countries.optionUruguay', value: 'UY' },
  { label: 'common.countries.optionUzbekistan', value: 'UZ' },
  { label: 'common.countries.optionVanuatu', value: 'VU' },
  { label: 'common.countries.optionVenezuela', value: 'VE' },
  { label: 'common.countries.optionVietNam', value: 'VN' },
  { label: 'common.countries.optionVirginIslandsBritish', value: 'VG' },
  { label: 'common.countries.optionVirginIslandsUS', value: 'VI' },
  { label: 'common.countries.optionWallisAndFutuna', value: 'WF' },
  { label: 'common.countries.optionWesternSahara', value: 'EH' },
  { label: 'common.countries.optionYemen', value: 'YE' },
  { label: 'common.countries.optionZambia', value: 'ZM' },
  { label: 'common.countries.optionZimbabwe', value: 'ZW' }
]
